// extracted by mini-css-extract-plugin
module.exports = {"dot":"ChatBotHeader_dot__3f4LN"};